class TdTabs extends HTMLElement {
    connectedCallback() {
        const tabs = this.querySelectorAll('li[role="tab"]');
        const tabList = this.querySelector('ul[role="tablist"]');

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", this.changeTabs);
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        tabList.addEventListener("keydown", (e) => {
            // Move right
            if (e.keyCode === 39 || e.keyCode === 37) {
                tabs[tabFocus].setAttribute("tabindex", -1);

                if (e.keyCode === 39) {
                    tabFocus++;

                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.keyCode === 37) {
                    tabFocus--;

                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
    }

    changeTabs(event) {
        const target = event.currentTarget;
        const parent = target.parentNode;
        const grandparent = parent.parentNode;

        // Remove all current selected tabs
        parent.querySelectorAll('[aria-selected="true"]').forEach((node) => node.setAttribute("aria-selected", false));

        // Set this tab as selected
        target.setAttribute("aria-selected", true);

        // Hide all tab panels
        grandparent.querySelectorAll('[role="tabpanel"]').forEach((node) => node.setAttribute("hidden", true));

        // Show the selected panel
        if (target.tagName === "IMG") {
            grandparent.querySelector(`#${target.parentNode.getAttribute("aria-controls")}`).removeAttribute("hidden");
        } else {
            grandparent.querySelector(`#${target.getAttribute("aria-controls")}`).removeAttribute("hidden");
        }
    }
}

customElements.define('td-tabs', TdTabs);